import { useState, useEffect } from "react";
import axios from "axios";

const useActivityTypes = (currentUser) => {
  const [activityTypes, setActivityTypes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchTypes = async () => {
      if (!currentUser) {
        console.warn("User not authenticated, skipping activity types fetch.");
        return;
      }

      setLoading(true);
      setError(null);

      try {
        const token = await currentUser.getIdToken();
        const response = await axios.get(
          "/api/activities/types",
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setActivityTypes(response.data.activityTypes);
      } catch (err) {
        console.error("Error fetching activity types:", err);
        setError(
          err.response?.data?.message || "Failed to fetch activity types."
        );
      } finally {
        setLoading(false);
      }
    };

    fetchTypes();
  }, [currentUser]);

  return { activityTypes, loading, error };
};

export default useActivityTypes;
